import React from 'react';
import ImageLoader from '../images/ImageLoader';
import Modal from '../modal/Modal';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreLink } from '../link/Link';

var BonusRewardCardModal = function BonusRewardCardModal(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      show = props.show,
      hide = props.hide,
      _props$ctaLink = props.ctaLink,
      ctaLink = _props$ctaLink === void 0 ? '/menu' : _props$ctaLink;
  var Image = model.Image,
      Name = model.Name,
      DisplayName = model.DisplayName,
      Description = model.Description;
  return /*#__PURE__*/React.createElement(Modal, {
    className: 'loyalty-modal loyalty-modal--bonus-reward-card',
    show: show,
    hide: hide,
    hideCloseButton: true,
    backdrop: true
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal__image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    type: 'product',
    className: "cb-card__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal__body-container'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-bonus-reward-card-modal__body-container__info',
    field: Name
  }), /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-bonus-reward-card-modal__body-container__header',
    field: DisplayName
  }), /*#__PURE__*/React.createElement(RichText, {
    field: Description,
    tag: "span",
    className: 'cb-bonus-reward-card-modal__body-container__copy'
  }), /*#__PURE__*/React.createElement(SitecoreLink, {
    field: {
      value: {
        href: ctaLink,
        text: 'Start order to redeem reward',
        title: 'Start order to redeem reward'
      }
    },
    className: 'cb-button-primary cb-bonus-reward-card-modal__body-container__button'
  }))));
};

export default BonusRewardCardModal;